module.exports = __webpack_public_path__ + "static/media/comic2009.58cb863e.png";